import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { environment } from '../../../environments/environment';
import { Company } from '../../auth/models/company/company';
import { airlineClassicToV2Url } from '../airline-classic-to-v2';
import { movedTo } from '../errors/page-moved';
import { UiVersionService } from '../services/ui-version.service';

/**
 * On the classic airline routes: an airline user who uses v2 opens the v2 page of a classic URL
 * that has one (airline-classic-to-v2.ts). Behind the same release flag as supplier v2
 * (`environment.supplierV2`, one switch for the whole v2 release, owner 2026-10-06): with the
 * flag off only the landing defaults to v2, as before. Uses v2 = the company is entitled and
 * the person has not chosen classic (`?ui=` on the URL or the tab's first load decides for that
 * tab). Also a canActivateChild on the tender, so moving between its classic pages is caught.
 */
export const airlineClassicToV2Guard: CanActivateFn = (_route, state) => {
    if (!environment.supplierV2 || !inject(Company).isBuyer() || !inject(UiVersionService).usesV2(state.url)) {
        return true;
    }
    const target = airlineClassicToV2Url(state.url);
    return target ? movedTo(target, state.url) : true;
};
